import Avatar from '@mui/material/Avatar';
import * as React from 'react';
import { useEffect, useState } from 'react';

import { colorFromString, initials } from "../../utils/avatar_url";
import { S3Controller } from "../../utils/s3.controller";

type Row = {
  name?: string;
  lastname?: string;
  avatarUrl?: string;
  avatarPath?: string;
  updatedAt?: string;
};

export function UserAvatar({ row, size = 50 }: { row: Row; size?: number }) {
  const [src, setSrc] = useState<string | undefined>(undefined);

  const label = `${row?.name ?? ''} ${row?.lastname ?? ''}`.trim();
  const fallback = initials(row?.name, row?.lastname);
  const bg = colorFromString(label || 'user');

  useEffect(() => {
    let mounted = true;

    async function loadAvatar() {
      try {
        console.log("ROW",row);
        // 1️⃣ se il backend ha già avatarUrl
        if (row.avatarUrl) {
          if (mounted)
            setSrc(row.avatarUrl);
          return;
        }

        // 2️⃣ se abbiamo solo il path S3
        if (row.avatarPath) {
          console.log("avatarPath",row.avatarPath);
          const signed = await S3Controller.getSignedUrl(row.avatarPath);
          if (mounted) setSrc(signed);
          return;
        }

        // 3️⃣ fallback
        if (mounted) setSrc(undefined);
      } catch (error) {
        console.error('Errore caricamento avatar:', error);
        if (mounted) setSrc(undefined);
      }
    }

    loadAvatar();

    return () => {
      mounted = false;
    };
  }, [row.avatarUrl, row.avatarPath, row.updatedAt]);

  return (
    <Avatar
      alt={label || 'User'}
      src={src}
      imgProps={{ referrerPolicy: 'no-referrer' }}
      sx={{
        width: size,
        height: size,
        bgcolor: bg,
        fontWeight: 700,
      }}
    >
      {fallback}
    </Avatar>
  );
}
